var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-nav"},_vm._l((_vm.buttons),function(button){return _c('router-link',{key:button.key,staticClass:"button-link",attrs:{"to":button.to},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var navigate = ref.navigate;
var href = ref.href;
return [_c('select-button',{attrs:{"tag":"a","href":href,"is-selected":_vm.selectedKey === button.key},on:{"select":navigate}},[_vm._v(" "+_vm._s(button.label)+" ")])]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }